import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "icon icon-comment-full",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.21,1.12c-2.3,0-4.59,0-6.89,0-1.24,0-2.48,0-3.72,0-1.15,.01-2.08,.86-2.09,1.96-.02,2.28-.02,4.57,0,6.85,0,.91,.73,1.72,1.61,1.91,.14,.03,.27,.04,.44,.07v2.98c.16-.1,.25-.16,.33-.22,1.25-.87,2.49-1.74,3.75-2.59,.16-.11,.37-.17,.56-.17,2-.01,4.01,0,6.02,0,1.42,0,2.28-.86,2.28-2.27,0-2.07,0-4.14,0-6.21,0-1.45-.85-2.29-2.29-2.29Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.54,4.23h6.92v.85H4.54v-.85Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.45,6.12s.03,.05,.03,.07q.06,.79-.72,.79H4.54v-.86h6.91Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.53,8.82v-.83h6.93v.83H4.53Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}